import LectureLessonModelBase from '../_generated/modelBases/lecture-lesson-model-base';

export default class LectureLessonModel extends LectureLessonModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
